import { modalAnatomy } from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'
import { mode } from '@chakra-ui/theme-tools'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(modalAnatomy.keys)

const baseStyleDialog = defineStyle(props => {
  return {
    bg: `${mode('white', 'neutral.50')(props)}`,
    border: '1px',
    borderColor: `${mode('neutral.200', 'whiteAlpha.300')(props)}`,
  }
})

const baseStyleOverlay = defineStyle(() => {
  return {
    bg: 'blackAlpha.600',
  }
})

const baseStyle = definePartsStyle(props => ({
  dialog: baseStyleDialog(props),
  overlay: baseStyleOverlay(),
}))

export const Modal = defineMultiStyleConfig({
  baseStyle,
})
